var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('editor', _vm._g(_vm._b({
    attrs: {
      "width": "100%",
      "height": _vm.calculatedHeight,
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  }, 'editor', _vm.$attrs, false), Object.assign({}, _vm.$listeners, {
    input: _vm.handleValueChanges
  })));
}
var staticRenderFns = []

export { render, staticRenderFns }